import Typography from 'app/components/Typography';

import { ReactComponent as EmptyNotificationIcon } from 'app/assets/icons/empty-notification.svg';

export const EmptyAlert = () => {
  return (
    <div className="d-flex flex-column flex-center" style={{ flexGrow: 1 }}>
      <EmptyNotificationIcon />
      <Typography variant="body-1" color="neutral-6">
        Alerts are empty.
      </Typography>
      <Typography variant="body-1" color="neutral-6">
        Check back later for new alerts.
      </Typography>
    </div>
  );
};
